import { Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Formik, Form } from 'formik';
import Axios from 'axios';
import * as Yup from 'yup';
import ErrorMessages from '../../errorConfig';
import UserRegistrationComponent from './UserRegistrationComponent';
import PmsUrlConfig from '../../urlConfig';
import pmsConstants from '../../pmsConstants';
import { getPractice, logout, setAuthToken } from '../common';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getUserGroups, getMatrixClient } from '../matrix/matrixFuntions.js';
const AddUserSchema = Yup.object().shape({
    firstname: Yup.string().required(ErrorMessages.FIRSTNAME_REQUIRED),
    lastname: Yup.string().required(ErrorMessages.LASTNAME_REQUIRED),
    // username: Yup.string().email(ErrorMessages.USERNAME_INVALID).required(ErrorMessages.USERNAME_REQUIRED),
    password: Yup.string()
        .required(ErrorMessages.PASSWORD_REQUIRED)
        .min(8, ErrorMessages.PASSWORD_LENGTH),
    confPassword: Yup.string()
        .oneOf([Yup.ref('password')], ErrorMessages.PASSWORDS_DONT_MATCH),
});

export default function AddUserForm({ onSuccess }) {

    const dispatch = useDispatch();
    const practiceDetails = useSelector(state => state.practiceDetails);
    if (!practiceDetails || practiceDetails.practice == null)
        <Navigate replace to={`${PmsUrlConfig.LOGIN_URL}`} />

    const practice = practiceDetails.practice;

    const practiceId = practice._id;

    const loginDetails = useSelector(state => state.loginDetails);
    var token = "";
    if (loginDetails) {

        token = loginDetails.jwtToken;
    }

    const clearInputFields = () => {
        document.getElementById("add-user-form").reset();
        Array.from(document.getElementById("add-user-form").getElementsByClassName("invalid-feedback")).forEach(
            divElem => (divElem.innerHTML = "")
        );
    }

    return (
        <div className="w-full">

            <Formik
                initialValues={{
                    firstname: '',
                    lastname: '',
                    userEmail: '',
                    username: '',
                    phoneNo: '',
                    password: '',
                    confPassword: '',
                    user_type: pmsConstants.USER_TYPE_STAFF
                }}
                validationSchema={AddUserSchema}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    // same shape as initial values 
                    var addUserUrl = PmsUrlConfig.BOS_ADD_USER_URL + practiceId
                    setAuthToken(token);
                    console.log('Practice object:', practice);
                    console.log('synapse_practice_members_group_name:', practice.synapse_practice_members_group_name);
                    Axios.post(addUserUrl, {
                        firstname: values.firstname,
                        lastname: values.lastname,
                        email: values.userEmail,
                        username: values.username,
                        phoneNum: values.phoneNo.replace(/[^\d]/g, ''),
                        password: values.password,
                        password_confirm: values.password,
                        user_type: values.user_type,
                        active_user: true,
                        synapse_user_groups: [practice.synapse_practice_members_group_name || '']
                    }
                    ).then((response) => {
                        console.log('Response status:', response.status);
                        console.log('Response data:', response.data);
                        
                        if (response.status === 200) {
                            toast.success('User added successfully!', {
                                position: "top-center",
                                autoClose: 3000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                            resetForm();
                            dispatch({
                                type: 'addUserSuccess',
                            })
                            getPractice(practice._id, dispatch, token);
                            clearInputFields();
                            
                            // 🔍 VERIFY GROUP MEMBERSHIP AFTER USER CREATION
                            console.log('🔍 === VERIFYING NEW USER GROUP MEMBERSHIP ===');
                            console.log('New user data:', response.data);
                            
                            // Get the newly created user's synapse user ID
                            const newUserSynapseId = response.data?.synapse_user_id;
                            if (newUserSynapseId) {
                                console.log(`Checking group membership for new user: ${newUserSynapseId}`);
                                
                                // Get matrix client for verification
                                const matrixClient = getMatrixClient(loginDetails?.jwtToken, loginDetails?.loggedInUser?.synapse_user_id);
                                
                                if (matrixClient) {
                                    // Wait a moment for backend to complete group addition
                                    setTimeout(async () => {
                                        try {
                                            const membershipInfo = await getUserGroups(matrixClient, newUserSynapseId);
                                            
                                            console.log('📊 NEW USER GROUP AND ROOM MEMBERSHIP:', membershipInfo);
                                            
                                            // Check if user belongs to any practice-related groups
                                            const practiceGroups = membershipInfo.groups.filter(group => 
                                                group.name.toLowerCase().includes('practice') ||
                                                group.name.toLowerCase().includes('group') ||
                                                group.roomId.includes(practice._id)
                                            );
                                            
                                            if (practiceGroups.length > 0) {
                                                console.log('✅ SUCCESS: New user was added to practice group(s)!', practiceGroups);
                                                toast.success(`User added to ${practiceGroups.length} practice group(s) successfully!`, {
                                                    position: "top-center",
                                                    autoClose: 3000,
                                                    hideProgressBar: true,
                                                });
                                            } else {
                                                console.log('❌ WARNING: New user was NOT added to practice group!');
                                                console.log('User groups:', membershipInfo.groups);
                                                console.log('User rooms:', membershipInfo.rooms);
                                                toast.warning('User created but not added to practice group', {
                                                    position: "top-center",
                                                    autoClose: 5000,
                                                    hideProgressBar: true,
                                                });
                                            }
                                        } catch (error) {
                                            console.error('Error verifying group membership:', error);
                                        }
                                    }, 3000); // Wait 3 seconds for backend processing
                                } else {
                                    console.log('❌ Matrix client not available for verification');
                                }
                            } else {
                                console.log('❌ No synapse_user_id found in response for new user');
                            }
                            
                            // Call onSuccess callback to close modal
                            if (onSuccess) {
                                onSuccess();
                            }
                        }
                        else if (response.status === 400) {
                            setSubmitting(false);
                            const errorMessage = response.data?.error_code?.description || ErrorMessages.SERVER_ERROR;
                            toast.error(errorMessage, {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                            });
                            dispatch({
                                type: 'practiceUpdateError',
                                payload: errorMessage
                            })
                        }
                        else if (response.status === 401 || response.status === 403) {
                            logout();
                            //TODO: Redirect to login page
                        }
                    }).catch((error) => {
                        setSubmitting(false);
                        console.log('Error caught:', error);
                        console.log('Error response:', error.response);
                        console.log('Error status:', error.response?.status);
                        console.log('Error data:', error.response?.data);
                        
                        const errorMessage = error.response?.data?.error_code?.description || ErrorMessages.SERVER_ERROR;
                        toast.error(errorMessage, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true
                        });
                        
                        if (error.response.data !== null && error.response.data.error_code !== null) {
                            dispatch({
                                type: 'practiceUpdateError',
                                payload: errorMessage
                            })
                        }
                    })
                }}
            >
                {({ errors, touched, values, handleChange, isSubmitting, handleReset, setFieldValue }) => (
                    <Form data-testid='password-form' id="add-user-form" className="w-full">
                        <UserRegistrationComponent
                            errors={errors}
                            touched={touched}
                            values={values}
                            handleChange={handleChange}
                            prefix={'staffSignup'}
                            editPage={false}
                            dispatch={dispatch}
                            setFieldValue={setFieldValue}
                        />

                        {/* Action Buttons */}
                        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mt-6">
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="px-8 py-2.5 bg-[#0B6D76] hover:bg-[#0A5A62] disabled:bg-gray-400 text-white font-semibold text-sm rounded-lg shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:ring-offset-2 min-w-[120px]"
                            >
                                {isSubmitting ? "Adding.." : "Add"}
                            </button>
                            <button
                                type="button"
                                onClick={handleReset}
                                className="px-8 py-2.5 bg-gray-100 border border-teal-300 hover:bg-gray-200 text-teal-600 font-semibold text-sm rounded-lg shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 min-w-[120px]"
                            >
                                Reset
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>

    );


}